import { ProctoringStep } from "../../index"
import { FaceDetectionView } from "./_components/FaceDetectionView"
import { WelcomeView } from "./_components/WelcomeView"

interface LeftPanelProps {
  step: ProctoringStep
  userFirstName?: string
  assessmentName: string
  cpatQuestions: number
  cpatDurationInMinutes: number
}

const LeftPanel = ({
  step,
  userFirstName,
  assessmentName,
  cpatQuestions,
  cpatDurationInMinutes,
}: LeftPanelProps) => {
  return (
    <div className="hidden flex-1 flex-col justify-center bg-white p-4 md:p-6 lg:flex lg:bg-transparent lg:p-12 xl:p-20">
      <div className="mx-auto w-full max-w-[480px]">
        {step === ProctoringStep.SYSTEM_CHECK && (
          <WelcomeView
            userFirstName={userFirstName}
            assessmentName={assessmentName}
            cpatQuestions={cpatQuestions}
            cpatDurationInMinutes={cpatDurationInMinutes}
          />
        )}{" "}
        {step === ProctoringStep.FACE_CAPTURE && <FaceDetectionView />}
      </div>
    </div>
  )
}

export default LeftPanel
